<template>
  <div>
    <div style="margin:15px 0">
      <!-- 面包屑 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/SetMeal' }">套餐</el-breadcrumb-item>
        <el-breadcrumb-item>新增套餐</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div>
      <el-input
        v-model="packageName"
        placeholder="请输入套餐名称"
        @change="PackageName"
        style="width:500px"
      ></el-input>
      <div style="margin:10px 0;float:right;">
        <div style="margin:10px 0 20px 0">
          <span style="margin:0 30px">合计</span>
          <span style="margin:0 30px">景区数量:<span>{{scenicSpotNumber}}</span></span>
          <span style="margin:0 30px">原价格:<span>{{originalPrice}}</span></span>
          <!-- <span style="margin:0 30px">套餐价格:<span>{{packageTotalPrice}}</span></span> -->
        </div>
        <div style="float:right">
          <el-button
            type="primary"
            @click="goSetMeal"
          >添加套餐</el-button>
          <!-- <el-button>取消</el-button> -->
        </div>
      </div>
      <div style="margin-top:20px">
        <el-table
          :data="tableData"
          @selection-change="handleSelectionChange"
          style="width: 100%"
        >
          <el-table-column
            type="selection"
            width="55"
          >
          </el-table-column>

          <el-table-column label="景区名称">
            <template slot-scope="scope">
              <span>{{scope.row.area_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="picture_url"
            label="图片"
          >
            <template slot-scope="scope">
              <img
                v-if="scope.row.area_pic"
                :src="scope.row.area_pic"
                alt=""
                style="width:80px;height:80px"
              >
              <img
                src="../assets/zhanwei.png"
                alt=""
                v-if="!scope.row.area_pic"
                style="width:80px;height:80px"
              >
            </template>
          </el-table-column>
          <el-table-column label="景区评级">
            <template slot-scope="scope">
              <span>{{scope.row.area_leavel}}</span>
            </template>
          </el-table-column>

          <el-table-column label="语音价格">
            <template slot-scope="scope">
              <span>{{scope.row.voice_price}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="原价格">
          <template slot-scope="scope">
            <span>{{scope.row.date}}</span>
          </template>
        </el-table-column> -->
          <!-- <el-table-column label="套餐价格">
            <template slot-scope="scope">
              <span>{{scope.row.area_ticket}}</span>
              <el-input
                placeholder="请输入套餐价格"
                type="number"
                v-model="packagePriceNumber[scope.$index]"
                @change="changePackagePrice"
              ></el-input>
              <p style="font-size:10px; color:#CCC">请输入套餐价格</p>
            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <!-- 分页区 -->
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total,  prev, pager, next, jumper"
        :total="total"
        style="text-align:right;margin:0 16px 10px 0;border-radius:20px;"
      >
      </el-pagination>
      <!-- 创建套餐按钮 -->
      <!-- <div style="float:right">
        <el-button
          type="primary"
          @click="goSetMeal"
        >添加套餐</el-button>
        <el-button>取消</el-button>
      </div> -->
    </div>

  </div>
</template>

<script>
import qs from "qs";
export default {
  props: {
    pageSize: {
      type: Number,
      default: 10,

    }
  },
  data () {
    return {
      tableData: [],
      multipleSelection: [],
      packageName: '',
      currentPage: 1,      //分页
      total: 0,
      mulSelectIds: [],
      // packagePriceNumber: [],     //套餐价格输入框
      scenicSpotNumber: 0,
      originalPrice: 0,//合计原价格累计
      packageTotalPrice: 0,
      newAddDialogVisible: false,
      newAddForm: {
        marketName: '',
        marketAddress: '',
        name: '',
        phone: ''
      },
      newAddRules: {
        marketName: [
          { required: true, message: '请输入套餐名称', trigger: 'blur' },
        ]
      },
      formLabelWidth: '120px',
    }
  },
  methods: {
    // 添加景区名称
    PackageName (value) {
      var packageName = value
      // console.log(packageName)
    },
    // 设置套餐价格
    changePackagePrice (value) {
      // console.log('========================')
      // console.log(value)
      // var packagenumber = 0
      // this.packageTotalPrice = 0
      // for (var i = 0; i < this.packagePriceNumber.length; i++) {
      //   if (this.packagePriceNumber[i]) {
      //     this.packageTotalPrice = this.packageTotalPrice + parseFloat(this.packagePriceNumber[i])
      //   }
      // }
    },
    //查询景点
    findScenicSpot () {
      var userData = qs.parse(sessionStorage.getItem("userData"));
      var that = this;
      var salesInfoData = {
        count: true,
        // area_id: that.areaID,
        // orderby: "area_id desc",
        pageindex: this.currentPage,
        pagesize: 10
      };
      var salesInfoParams = {
        methodUrl: "/admin/getScenicArea",
        jsonParam: qs.stringify(salesInfoData)
      };
      this.$axios.postRequest(salesInfoParams).then(
        function (res) {
          //成功之后处理逻辑
          that.tableData = res.data.list;
          that.total = res.data.totalcount;
        },
        function (res) {
          //失败之后处理逻辑
          console.log("error:");
        }
      );
    },
    // 添加创建
    submitForm (formName) {

    },
    // 新增套餐
    goSetMeal () {
      var userData = qs.parse(sessionStorage.getItem("userData"));
      var that = this;
      var area_ids = []
      var prices = []
      // console.log(this.mulSelectIds)
      for (var i = 0; i < this.mulSelectIds.length; i++) {
        for (var j = 0; j < this.mulSelectIds[i].ids.length; j++) {
          area_ids.push(this.mulSelectIds[i].ids[j])
        }
      }
      // this.packagePriceNumber.forEach(element => {
      //   prices.push(element)
      // });
      var areaID = area_ids.join(",")
      console.log('========ssss===========')
      console.log(areaID)
      console.log(prices.join(','), 1213213)
      var salesInfoData = {
        do_lx: 1,
        package_id: 0,
        package_name: this.packageName,
        area_id: areaID,
        // area_price: prices.join(',')
      };
      if (this.packageName == '') {
        this.$confirm('请输入套餐名称')
      } else {
        var salesInfoParams = {
          methodUrl: "/admin/addPackageInfo",
          jsonParam: qs.stringify(salesInfoData)
        };
        this.$axios.postRequest(salesInfoParams).then(
          function (res) {
            //成功之后处理逻辑
            that.$router.push({
              path: "/SetMeal",
              query: {
              }
            })
          },
          function (res) {
            //失败之后处理逻辑
            console.log("error:");
          }
        );
      }
    },
    // goSetMeal () {
    //   this.newAddDialogVisible = true;
    // },
    handleSelectionChange (val) {
      // console.log(val, 1)
      this.multipleSelection = val;
      if (this.mulSelectIds.length != 0) {
        this.mulSelectIds.forEach((item, i) => {
          // console.log(i, 2)
          // console.log(item, 3)
          if (item.index == this.currentPage) {
            this.mulSelectIds.splice(i, 1)
            // console.log(this.mulSelectIds)
          }
        })
      }
      var selectInfo = {}
      selectInfo.index = this.currentPage
      var ids = []
      var itemPrice = 0
      val.forEach(element => {
        itemPrice = itemPrice + parseFloat(element.voice_price)
        ids.push(element.area_id)
      });
      selectInfo.price = itemPrice
      selectInfo.ids = ids
      this.mulSelectIds.push(selectInfo)
      // console.log(this.mulSelectIds)
      var size = 0
      var price = 0
      this.mulSelectIds.forEach(item => {
        size = size + parseInt(item.ids.length);
        price = price + parseFloat(item.price)
      });
      this.originalPrice = price
      this.scenicSpotNumber = size
    },
    // 分页
    handleSizeChange (val) {
      this.pageSize = val;
      this.findScenicSpot();
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      this.findScenicSpot();
    },
  },
  mounted () {
    this.findScenicSpot()
  }
}
</script>

<style>
p span {
  margin: 0 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/SetMealList.vue